import {
  BACKROOM_MODULE_STATUS_DISPLAY,
  BACKROOM_MODULE_STATUS_OPTIONS,
} from '../constants';
import { CheckboxActive, CheckboxDefault } from '@/assets/svg';
import { handleSelectAll, renderValue } from '@/helpers';
import { ButtonEnhance } from '@/module/common/componentUI/commonStyleComponents';
import CustomAsyncAutoComplete from '@/new-components/CustomAsyncAutoComplete';
import CustomDate from '@/new-components/CustomDate';
import CustomSelectContainer from '@/new-components/CustomSelectOld/CustomSelectContainer';
import {
  Grid,
  Button,
  withStyles,
  Checkbox,
  Paper,
  Box,
  TextField,
  makeStyles,
} from '@material-ui/core';
import { Autorenew } from '@material-ui/icons';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';

const useStyles = makeStyles({
  checkboxIcon: {
    padding: 0,
    marginRight: 4,
  },
  tagStyle: {
    maxWidth: 'calc(100% - 60px)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  selectWrapper: {
    '& .MuiIconButton-root:hover': {
      backgroundColor: 'transparent',
    },
  },
});

const CustomButton = withStyles({
  root: {
    margin: 5,
    paddingLeft: 40,
    paddingRight: 40,

    height: 40,
    minWidth: 160,

    textTransform: 'unset',
    fontWeight: 600,
    borderRadius: 50,
  },
})(Button);

const CustomFilterInput = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      height: 40,
      borderRadius: 8,
      '& input': {
        padding: 0,
        marginLeft: 0,
      },
      '& input::placeholder': {
        opacity: 1,
        color: '#999999',
      },
    },
  },
})(TextField);

const GroupSearch = ({
  filterOption,
  onFilterOptionClear,
  onFilterOptionChange,
  setFilterOption,
  startTime,
  setStartTime,
  endTime,
  setEndTime,
  onResetFilterOps,

  backroomStatuses,
  setBackroomStatuses,
  locationIds,
  setLocationIds,
  defaultStartDate = '',
  defaultEndDate = '',
}) => {
  const classes = useStyles();
  const onChangeStartDate = (value) => {
    const newValue = moment(value).startOf('date');

    setStartTime(value ? newValue : defaultStartDate);
    setFilterOption({
      ...filterOption,
      startTime: value ? newValue : defaultStartDate,
    });
  };

  const onChangeEndDate = (value) => {
    const newValue = moment(value).endOf('date');
    setEndTime(value ? newValue : defaultEndDate);
    setFilterOption({
      ...filterOption,
      endTime: value ? newValue : defaultEndDate,
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        marginBottom: 16,
      }}
    >
      <Grid container spacing={3} alignItems="flex-end">
        <Grid item md={3} sm={6} xs={12}>
          <CustomSelectContainer
            isFullWidth
            height="40px"
            filterValue={backroomStatuses || []}
            data={BACKROOM_MODULE_STATUS_OPTIONS}
            label="label"
            renderValue={renderValue(
              backroomStatuses.map(
                (status) => BACKROOM_MODULE_STATUS_DISPLAY[status] || status
              ),
              'Statuses',
              'All statuses'
            )}
            onClear={() => {
              setBackroomStatuses([]);
              setFilterOption({
                ...filterOption,
                statuses: [],
              });
            }}
            onChange={(e) => {
              const value = handleSelectAll(
                e.target.value,
                BACKROOM_MODULE_STATUS_OPTIONS.map((item) => item.value),
                backroomStatuses
              );
              setFilterOption({
                ...filterOption,
                statuses: value,
              });
              setBackroomStatuses(value);
            }}
            labelSelectAll={'All statuses'}
            useSelectAll
            checkedAll={
              BACKROOM_MODULE_STATUS_OPTIONS.map((item) => item.value)
                .length === backroomStatuses.length
            }
          />
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          <CustomAsyncAutoComplete
            multiple
            disableCloseOnSelect
            isLocation
            endpoint="locations/filter"
            method="post"
            nameKey="name"
            value={locationIds}
            onChange={(e, value) => {
              setFilterOption({
                ...filterOption,
                locationIds: value.map((it) => it.id),
              });
              setLocationIds(value);
            }}
            defaultFilter={{
              sortByName: true,
            }}
            getOptionLabel={(option) => option?.name}
            renderInput={(params) => (
              <CustomFilterInput
                {...params}
                variant="outlined"
                placeholder={isEmpty(locationIds) ? 'All locations' : ''}
              />
            )}
            renderOption={(option, { selected }) => {
              return (
                <Box display="flex" gridGap={4}>
                  <Checkbox
                    icon={<CheckboxDefault width={20} height={20} />}
                    checkedIcon={<CheckboxActive width={20} height={20} />}
                    checked={selected}
                    color="primary"
                    className={classes.checkboxIcon}
                  />
                  <span>{option.name}</span>
                </Box>
              );
            }}
            renderTags={(value, getTagProps) => {
              let newValue = value.filter((it) => locationIds?.includes(it));
              return newValue.length === 1 ? (
                <div className={classes.tagStyle}>{newValue[0].name}</div>
              ) : newValue.length > 1 ? (
                <Box>Locations ({newValue.length})</Box>
              ) : (
                ''
              );
            }}
            PaperComponent={({ children, ...other }) => (
              <Paper
                {...other}
                style={{ width: 320 }}
                className={classes.selectWrapper}
              >
                {children}
              </Paper>
            )}
            style={{ width: '100%', height: 40 }}
          />
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          <CustomDate
            selectedDate={startTime}
            isFullWidth
            placeholder={startTime ? `${startTime}` : 'Start Date'}
            clearable
            maxDate={endTime ? moment(endTime) : null}
            onChange={onChangeStartDate}
            onClear={() => {
              setStartTime('');
              setFilterOption({
                ...filterOption,
                startTime: '',
              });
            }}
            style={{ height: 40 }}
          />
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          <CustomDate
            selectedDate={endTime}
            isFullWidth
            placeholder={endTime ? `${endTime}` : 'End Date'}
            clearable
            minDate={startTime ? moment(startTime) : null}
            onChange={onChangeEndDate}
            onClear={() => {
              setEndTime('');
              setFilterOption({
                ...filterOption,
                endTime: '',
              });
            }}
            style={{ height: 40 }}
          />
        </Grid>
        <Grid container justify="flex-end" style={{ marginRight: 16 }}>
          <CustomButton
            onClick={() => {
              onResetFilterOps();
            }}
            variant="contained"
            color="primary"
            endIcon={<Autorenew />}
            style={{ borderRadius: 50, margin: 5 }}
          >
            Reset Filter
          </CustomButton>
        </Grid>
      </Grid>
    </div>
  );
};

export const StyledButtonEnhance = styled(ButtonEnhance)`
  max-width: 160px;
  display: flex;
  align-self: flex-end;
  justify-content: center;
  margin: 12px;
  .add-group {
    display: flex;
    width: fit-content;
    align-items: center;
    margin-top: -2px;
    span {
      margin-right: 8px;
      color: #cacfd3;
    }
  }
`;

export default GroupSearch;
